import { useEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { useUserUiPreferences } from '@/hooks/use-user-ui-preferences'

const UserUiPreferencesSync = () => {
  const { user, isAuthenticated } = useAuth()
  const { hydrate } = useUserUiPreferences()

  useEffect(() => {
    if (!isAuthenticated || !user?.uid) return
    void hydrate().catch(() => {
      // Le cache local reste en place si l'API ne répond pas.
    })
  }, [hydrate, isAuthenticated, user?.uid])

  return null
}

export default UserUiPreferencesSync
